export enum Walkability {
    LESS_200 = "LESS_200",
	LESS_100 = "LESS_100",
	NOT_WALKABLE = "NOT_WALKABLE",
	OTHER = "OTHER"
}